import { combineReducers } from "redux";
import {
  USERGROUP_CLEAR_ACTIVE,
  USERGROUP_CREATE,
  USERGROUP_GET_BY_ID,
  USERGROUP_PATCH,
  USERGROUP_SEARCH,
} from "../actions/userGroups";
import { publishActionToast } from "../services/toasts";

const successToasts = {
  [USERGROUP_CREATE]: "Create user group successfully",
  [USERGROUP_PATCH]: "Updated user group successfully",
};

const byId = (state = {}, action) => {
  publishActionToast(action, "USERGROUP_", successToasts);

  switch (action.type) {
    case `${USERGROUP_SEARCH}_SUCCESS`:
    case `${USERGROUP_GET_BY_ID}_SUCCESS`:
    case `${USERGROUP_CREATE}_SUCCESS`:
    case `${USERGROUP_PATCH}_SUCCESS`:
      return {
        ...state,
        ...action.response.entities.userGroup,
      };

    default:
      break;
  }

  return state;
};

const defaultActive = {
  dashboard: [],
  dashboardLastUpdate: 0,
  activeUserGroup: null,
  lastEdit: 0,
  error: null,
  pagination: {
    offset: 0,
    pageSize: 50,
    resultCount: 0,
  },
};

const active = (state = defaultActive, action) => {
  switch (action.type) {
    case USERGROUP_CLEAR_ACTIVE:
      return {
        ...defaultActive,
      };

    case `${USERGROUP_SEARCH}_SUCCESS`:
      return {
        ...state,
        dashboard: [...action.response.result],
        dashboardLastUpdate: new Date().getTime(),
        pagination: {
          ...action.response.pagination,
          pageSize: defaultActive.pagination.pageSize,
        },
      };

    case `${USERGROUP_GET_BY_ID}_SUCCESS`:
      return {
        ...state,
        activeUserGroup: action.response.result,
      };

    case `${USERGROUP_CREATE}_SUCCESS`:
    case `${USERGROUP_PATCH}_SUCCESS`:
      return {
        ...state,
        activeUserGroup: action.response.result,
        lastEdit: new Date().getTime(),
      };

    default:
      break;
  }

  return state;
};

export default combineReducers({
  active,
  byId,
});

export const getActiveUserGroup = (state) =>
  state.active.activeUserGroup
    ? state.byId[state.active.activeUserGroup]
    : null;
export const getAll = (state) =>
  state.active.dashboard.map((id) => state.byId[id]);
export const getPagination = (state) => state.active.pagination;
export const getLastEdit = (state) => state.active.lastEdit;
